class NewsParam {
  categoryType = ''
  type = 1
  unitIdList = new Array<string>()
  contendLength = 5
}

export default NewsParam
